module.exports = window.Stripe;